import { FieldValidator } from '@ov-suite/helpers-angular';
import { UserModel } from '@ov-suite/models-idm';

export class PhoneValidator implements FieldValidator<UserModel> {
  errorMessage = 'Phone number must Start with +27';

  async validateCreate(user: UserModel) {
    return this.validate(user);
  }

  async validateUpdate(user: UserModel) {
    return this.validate(user);
  }

  async validate(user: UserModel): Promise<boolean> {
    return !user.phoneNumber || !!user.phoneNumber?.includes('+27');
  }

  async required(): Promise<boolean> {
    return false;
  }
}
